import Instance from "../../../../Axios";

// New Actions for the app

const GetFuncionarioByNIF = (nif) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/funcionarioByNIF/${nif}`)
    .then(({ data }) => {
      dispatch({
        type: "GET_FUNCIONARIO_BY_NIF",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetFuncionarioByNIF;